module.exports = __webpack_public_path__ + "static/media/38.c03ec847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/38.jpg
// module id = 599
// module chunks = 0